import api from '../utils/api';
export const renewToken = (config = {}) => {
    const { options } = config;
    return api({
        url: 'auth/renew-token',
        method: 'POST',
        ...options
    });
}